module.exports = __webpack_public_path__ + "static/media/KlearNowLogo.6ea1c703.png";